import type { FaireProductEntity } from "../../entity_types/product";

export const p_xmuunp5uzx: FaireProductEntity = {
  token: "p_xmuunp5uzx",
  type: "product",
  name: "Witch Printed Leggings, tarot printed leggings",
  brandToken: "b_na6tfqypxs",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/567e77c0c6a291873dfecb2eb0931fe220586f32dc7085480592ddade48448dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78ab7e691066da7a940cbdbe9f0fe3cc393bc174d0d9d9efaacdc38a463af139.jpeg",
    "https://cdn.faire.com/fastly/7b5d1d6dee7e8e46332d06626cd5333244ed1db00959c4a740a429b0364498a8.jpeg",
    "https://cdn.faire.com/fastly/d685f2fc4e146a7485b2ed587965760fdc3aeed17d83a47e7dc5c6a382dd07aa.jpeg",
    "https://cdn.faire.com/fastly/0b9dbce3cf63b185645c0ec197aaabfbaffb3cd90b7f3f3e80c9238e0adb2d46.jpeg",
    "https://cdn.faire.com/fastly/6d314b0aedf703d8327a7adc7521b81d6f05d2ab2af1dc315660f419766504cd.jpeg",
    "https://cdn.faire.com/fastly/56361dbf4b4b71cc6c30d38372a4e98f41ce48312bca7c7803308ccabedd3032.jpeg"
  ],
  priceDollars: 20.79,
  description: "Designed to meet your everyday needs Triple Goddess Boutique’s exclusive collection can’t be found anywhere else. With two fully functional pockets designed to fit even the largest phones. 3” wide comfort waistband and custom fit to accommodate your unique body shape. The unique fabric blend will stretch to fit whether you are short or tall!\n\n\nOS fits 2-12\n\nTC fits 12-18\nTC2 fits 18-28\n\n\n92% Polyester, 8% Spandex",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:52.578Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
